/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Desc_TitleInputs */

const vi_shop_desc_title = /** @type {(inputs: Shop_Desc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả chi tiết`)
};

/**

* @param {Shop_Desc_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_desc_title = /** @type {((inputs?: Shop_Desc_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Desc_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_desc_title(inputs)
});